import setup from './moduleSetup';

export default {
    name: 'general',
    before: [],
    after: [],
    setup,
};
